/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import { CreatePageStepsEnum } from '../types';
import { StepModalOptionText } from '../styled';
import { LeasedOption, LeasedOptionWrapper } from './styled';
import Icon from '../../Icon';
import PassIcon from '../../../public/static/images/new_ad/icons/icon-pass.svg';
import CalendarIcon from '../../../public/static/images/new_ad/icons/icon-calendar.svg';
import { FORM_VALUES } from '../../../utils/helpers/constants';
import { ItemCreationLayout } from '../ItemCreationLayout';
import useScreenSize from '../../../hooks/useScreenSize';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';
import { useClient } from '../../../hooks/useClient';

interface SelectLeasedTypeStepProps {
  setPageStep: React.Dispatch<React.SetStateAction<CreatePageStepsEnum>>;
}

export const SelectLeasedTypeStep: React.FC<SelectLeasedTypeStepProps> = ({
  setPageStep
}) => {
  const { t } = useTranslation();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const onOptionClick = () => {
    setPageStep(CreatePageStepsEnum.PropertyType);
  };

  const leasedConfig = [
    {
      icon: PassIcon,
      text: t('new_ad.sell_estate'),
      dataStat: generateDataStat('create_ad_step1_sell', isSmall, isClient),
      onClick: () => {
        change(FORM_VALUES.leased, 'false');
        onOptionClick();
      }
    },
    {
      icon: CalendarIcon,
      text: t('new_ad.rent_estate'),
      dataStat: generateDataStat('create_ad_step1_rent', isSmall, isClient),
      onClick: () => {
        change(FORM_VALUES.leased, 'true');
        change(FORM_VALUES.paidDaily, 'false');
        onOptionClick();
      }
    }
  ];

  return (
    <ItemCreationLayout
      cypress="leased-modal"
      contentCypress="leased-modal__content"
    >
      <LeasedOptionWrapper>
        {leasedConfig.map(leasedType => (
          <LeasedOption
            key={leasedType.text}
            onClick={leasedType.onClick}
            data-cy="leased-modal__option"
            data-stat={leasedType.dataStat}
            $isLeasedOption
          >
            <Icon
              IconComponent={leasedType.icon}
              width={48}
              height={48}
              indent={false}
            />
            <StepModalOptionText tag="body_3">
              {leasedType.text}
            </StepModalOptionText>
          </LeasedOption>
        ))}
      </LeasedOptionWrapper>
    </ItemCreationLayout>
  );
};
